/**
 * Created by asiulik on 16.01.2018.
 */

define(['jquery', 'lodash', '../../utils'], function ($, _, Utils) {

    var $window = $(window);
    var $document = $(document);

    var MIN_SEARCH_CHARACTERS_TO_REQ = 3;
    var WRITE_TIMEOUT = 500;
    var SEARCH_RESULT_CONTENT_ID = "searchResultsContent";
    var QUERY_RESPONSE_RESULTS_ID = "queryResponseResults";
    var SEARCH_URL = '/';

    var templateResultItem = _.template('' +
        '<div class="result__item">' +
        '<header class="result__item__header"><%- header %></header>' +
        '<p class="result__item__text"><%- text %></p>' +
        '<div class="result__item__breadcrumps">' +
        '</div>' +
        '<div class="line background--brandGrey margin--top-20"></div>' +
        '</div>' +
        '');

    function Search(headerInstace, overlayInstance) {

        if (!headerInstace) {
            throw new Error('Search need headerInstace, passed undefined');
        }

        if(!overlayInstance) {
            throw new Error('Search need overlayInstace, passed undefined');
        }

        this.header = headerInstace;
        this.overlay = overlayInstance;

    }

    Search.prototype.init = function () {

        this.$search = $('#search');
        this.$searchInput = $('#searchInput');
        this.$searchQuickLinks = $('#searchQuickLinks');
        this.$searchResults = $('#searchResults');
        this.$searchResultsContent = $('#searchResultsContent');
        this.$searchResultsCount = $('#searchResultsCount');
        this.$searchPreloade = $('.search__preloader');
        this.$loadMorePreloade = $(document).find('#pageLoader');
        this.$searchNoResultsInfo = $('#searchNoResultInfo');

        this.searchUrl  = this.$search.data('searchUrl') || SEARCH_URL;

        this.searchOverlay = $('#searchOverlay');

        var _this = this;

        this.overlay.on('openOverlay', function(){
            if(_this.searchOverlay.hasClass('overlay--open')) {
                _this.$searchInput.focus();
            }
        });
        
        this.bindEvents();

    };

    Search.prototype.displaySearch = function () {

        var _this = this;
        var popup = this.$searchInput.closest('.overlay');

        popup.hasClass('overlay--open') ? hideOverlay() : showOverlay();

        function showOverlay(){
            _this.clearSearch();
            _this.overlay.openOverlay(popup);
            _this.setInputActive();
        }

        function hideOverlay(){
            _this.overlay.hideOverlay();
        }

    };

    Search.prototype.clearSearch = function(){
        this.$searchInput.val('');
        // this.$searchResultsContent.html('');
        this.$searchResults.hide();
        this.$searchQuickLinks.show();
    };

    Search.prototype.setInputActive = function(){
        this.$searchInput.focus();
    };

    Search.prototype.bindEvents = function () {

        var _this = this;

        this.$searchInput.on({
            keyup: function (e) {
                var $input = $(this);

                if(_this.writeTimeout) clearTimeout(_this.writeTimeout);

                _this.writeTimeout = setTimeout(function(){

                    var inputValue = $input.val();
                    if(inputValue) {
                        inputValue = inputValue.replace(/ /g, '+');
                    }

                    if(_this.searchPending) return;
                    if(inputValue.length < MIN_SEARCH_CHARACTERS_TO_REQ) return _this.clearSearchView()

                    _this.toggleSearchPreloader(true);

                    var queryParams = {'search': inputValue, 'showResults': (e && e.keyCode==13)?true:false};

                    window.tracking.trackGTM({
                        'event': 'search',
                        'action': 'searchAction',
                        'value': inputValue

                    });

                    window.tracking.trackGA([
                        'send',
                        'event',
                        'search',
                        'searchValue',
                        inputValue
                    ]);

                    _this.getSearchResults(queryParams, false).then(function(response) {
                        // console.log('search result respoinse', response);

                        $('.search__input').addClass('search__loader');
                        _this.$searchResults.show();
                        _this.$searchQuickLinks.hide();

                        _this.toggleSearchPreloader();

                        return _this.prepareResultsToDisplay(response);

                    }).then(function(preparedData){
                        $('.search__input').removeClass('search__loader');
                        _this.updateSearchView(preparedData);

                    });

                }, WRITE_TIMEOUT);
            }/*,
            keyup: function(e){
                console.log(e.keyCode);
            }*/
        });

        $(document).on( {
            'click': function(){

                //window.lastSearchQuery = _this.$searchInput.val();

            }
        }, '.search__results__content .result__item a');

        $(document).on( {
            'click': function(e){

                e.preventDefault();
                var $this = $(this);
                var url = $this.attr('href');

                $this.attr("disabled", "disabled");

                // console.log('url', url);
                _this.toggleLoadMorePreloader(true);
                _this.getSearchResults(null, url).then(function(response) {
                    // console.log('search result respoinse', response);
                    _this.toggleLoadMorePreloader(true);

                    return response;

                }).then(function(preparedData){
                    var tab = Utils.getQueryStringParams('tab', url);
                    $(document).find('#tab-'+tab).append($(preparedData).find('#tab-'+tab).html());
                    _this.toggleLoadMorePreloader(false);
                    $this.remove();
                    // _this.updateSearchView(preparedData);

                });

                e.preventDefault();

                return false;

            }
        }, '[data-search-load-more]');

        this.bindSearchTrigger();

    };

    Search.prototype.loadMore = function(){

    };

    Search.prototype.bindSearchTrigger = function(){

        var _this = this;

        $('#triggerSearchInput').on('focus', function(e){

            _this.displaySearch();
            _this.header.setIconActive('search');

        });

    };

    Search.prototype.checkLastQuery = function(){

        if(window.lastSearchQueryActive) {

            this.displaySearch();
            this.header.setIconActive('search');

            this.$searchInput.val(window.lastSearchQueryActive);
            this.$searchInput.trigger('input');

            window.lastSearchQuery = undefined;
            window.lastSearchQueryActive = undefined;

        }

    };

    Search.prototype.getSearchResults = function(queryParam, customUrl){

        var _this = this;
        var dfd = jQuery.Deferred();
        if( !customUrl ){
            customUrl = this.searchUrl;
            $.each(queryParam, function(key, value){
                customUrl = Utils.addQueryStringParamsToUrl(key, value, customUrl);
            });
            // Utils.addQueryStringParamsToUrl(key, value, this.searchUrl);
            // customUrl = this.searchUrl + '?' + $.param(queryParam);
        }

        $.get( customUrl ).then(function(data){
            dfd.resolve(data);

        });

        return dfd.promise();

    };

    Search.prototype.prepareResultsToDisplay = function(queryResponse) {

        var $queryResponse = $(queryResponse);

        var resultsItems = $queryResponse.find('.result__item');

        return {
            html: $queryResponse.find('#searchResults').html(),
            count: resultsItems.length
        };


    };

    Search.prototype.toggleSearchPreloader = function(displayState){


        return displayState ? this.$searchPreloade.addClass('preloader--show') :
            this.$searchPreloade.removeClass('preloader--show');

    };

    Search.prototype.toggleLoadMorePreloader = function(displayState){


        return displayState ? this.$loadMorePreloade.addClass('preloader--show') :
            this.$loadMorePreloade.removeClass('preloader--show');

    };

    Search.prototype.updateSearchView = function(results){

        this.updateResultsView(results);
        $('.tabs').tabs(
        );

    };

    Search.prototype.updateResultsView = function(results) {
        var _this = this;
        // this.$searchResultsCount.html(results.count);
        !results.count ? this.$searchNoResultsInfo.show() : this.$searchNoResultsInfo.hide();
        this.$searchResults.html(results.html);

        //workaround to make autocomplete links clickable
        this.$searchResults.find('.autocomplete__link').click(function(e){
            e.preventDefault();

            var inputValue = $(this).text();
            _this.getSearchResults(false, $(this).attr('href') ).then(function(response) {
                _this.$searchInput.val(inputValue);

                _this.$searchResults.show();
                _this.$searchQuickLinks.hide();

                _this.toggleSearchPreloader();

                return _this.prepareResultsToDisplay(response);

            }).then(function(preparedData){

                _this.updateSearchView(preparedData);

            });
            return false;
        });

    };

    Search.prototype.clearSearchView = function(){

        this.toggleSearchPreloader();

        this.$searchResultsContent.html('');
        this.$searchResults.hide();
        this.$searchQuickLinks.show();

    };

    return Search;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/search/search.js